import { useTranslation } from 'react-i18next';
import { type FC } from 'react';

import DraggableModal from '../draggableModal';
import CallAudioPlayer from '.';
import s from './styles.module.scss';

import type { TranscriptItem } from 'infrastructure/hooks/calls/use-get-call-transcribe/types';

interface Props {
  patientPhone?: string;
  patientName?: string;
  audioUrl: string;
  isOpen: boolean;
  close: () => void;
  callId: string;
  transcripts?: TranscriptItem[] | null;
  transcriptsLoading: boolean;
  showTranscript: boolean;
  toggleShowTranscript: () => void;
  callTranscribeErrorMessage?: string;
}

const CallAudioPlayerModal: FC<Props> = ({
  patientPhone,
  patientName,
  audioUrl,
  isOpen,
  close,
  callId,
  transcripts,
  transcriptsLoading,
  showTranscript,
  toggleShowTranscript,
  callTranscribeErrorMessage,
}) => {
  const { t } = useTranslation();

  return (
    <DraggableModal
      data-expanded={showTranscript}
      title={patientPhone ?? t('labels.callRecord')}
      subTitleClassName={s['modal-subtitle']}
      subTitle={patientName}
      isOpen={isOpen}
      toggle={close}
      modalClassName={s.modal}
      bodyClassName={s['modal-body']}
      footerClassName={s['modal-footer']}
    >
      <CallAudioPlayer
        audioUrl={audioUrl}
        callId={callId}
        transcripts={transcripts}
        transcriptsLoading={transcriptsLoading}
        showTranscript={showTranscript}
        toggleShowTranscript={toggleShowTranscript}
        callTranscribeErrorMessage={callTranscribeErrorMessage}
      />
    </DraggableModal>
  );
};

export default CallAudioPlayerModal;
